import { type ChatItem, ChatItemSourceType } from 'app/services/chatBot';
import { useEffect } from 'react';

export default function useHandleResponse({
  response,
  addChatItems,
  setIsTyping,
  isStale,
}: {
  response: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  addChatItems: (chatItems: ChatItem[]) => ReturnType<typeof setTimeout>[];
  setIsTyping: (isTyping: boolean) => void;
  action?: string;
  uuid?: string;
  isStale?: boolean;
}) {
  useEffect(() => {
    if (!response || isStale) {
      return;
    }

    let timeouts: ReturnType<typeof setTimeout>[] = [];

    if (response.chat_items && response.chat_items.length > 0) {
      timeouts = addChatItems(
        response.chat_items.filter((item: ChatItem) => item.source !== ChatItemSourceType.PATIENT)
      );
    } else {
      setIsTyping(false);
    }

    return () => {
      timeouts.forEach((timeout) => clearTimeout(timeout));
    };
  }, [response, isStale]); // eslint-disable-line react-hooks/exhaustive-deps
}
